/*
===============================================================================================================
                                 Copyright 2022-2026, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import { formatLocaleCurrency } from './locale-formatting';

export const convertCurrencyToDecimal = (amount) => (amount / 100).toFixed(2);

export const convertCurrencyToNumber = (amount) => Math.round(Number(amount) * 100);

const CURRENCY_CODE_MAP = {
  USD: 'USD',
  US: 'USD',
  JPY: 'JPY',
  JP: 'JPY',
  GBP: 'GBP',
  UK: 'GBP',
  GB: 'GBP',
  AUD: 'AUD',
  AU: 'AUD',
  SAR: 'SAR',
  SR: 'SAR',
  SA: 'SAR',
  NZD: 'NZD',
  NZ: 'NZD',
  EUR: 'EUR',
};

export const formatCurrency = (currency, amount, intlLocale) => {
  if (intlLocale) {
    const isoCode = CURRENCY_CODE_MAP[currency];
    if (isoCode) return formatLocaleCurrency(amount, isoCode, intlLocale);
  }

  switch (currency) {
    case 'USD':
    case 'US':
      return new Intl.NumberFormat('en-US',
        { style: 'currency', currency: 'USD' }).format(amount).concat(' USD');
    case 'JPY':
    case 'JP':
      return new Intl.NumberFormat('jp-JP',
        { style: 'currency', currency: 'JPY' }).format(amount).concat(' JPY');
    case 'GBP':
    case 'UK':
    case 'GB':
      return new Intl.NumberFormat('en-GB',
        { style: 'currency', currency: 'GBP' }).format(amount).concat(' GBP');
    case 'AUD':
    case 'AU':
      return new Intl.NumberFormat('en-AU',
        { style: 'currency', currency: 'AUD' }).format(amount).concat(' AUD');
    case 'SR':
    case 'SA':
      return new Intl.NumberFormat('ar-SA',
        { style: 'currency', currency: 'SAR' }).format(amount).concat(' SAR');
    case 'NZD':
    case 'NZ':
      return new Intl.NumberFormat('en-NZ',
        { style: 'currency', currency: 'NZD' }).format(amount).concat(' NZD');
    case 'EUR':
      return new Intl.NumberFormat('en-EU',
        { style: 'currency', currency: 'EUR' }).format(amount).concat(' EUR');
    default:
      return amount;
  }
};
